import './layout.styles.scss'

import React, { createContext, ReactNode } from 'react'

import { LeftSideBar, Navigation, UserMenuTopBar } from '@/components/core-v2'
import { useUser } from '@/utilities/hooks/useUser'

import { ClientsWithState } from '../clients/clients'
import { CurrentUserType } from '../clients/clients.state'

const isUserInRole = (user, roleName) => user?.roles?.includes(roleName)

interface IClientsLayoutContext {
  isPortfolioManagerScreen: boolean
  userType: CurrentUserType
}

const ClientsLayoutContext = createContext<IClientsLayoutContext>({
  isPortfolioManagerScreen: false,
  userType: 'admin'
})

export const ClientsLayoutProvider = ({
  children,
  isPortfolioManagerScreen
}: {
  children: ReactNode
  isPortfolioManagerScreen?: boolean
}) => {
  const { data: user } = useUser()
  const userType: CurrentUserType = isUserInRole(user, 'Client') ? 'client' : 'admin'

  const contextValue = React.useMemo(
    () => ({ isPortfolioManagerScreen, userType }),
    [isPortfolioManagerScreen, userType]
  )

  return (
    <ClientsLayoutContext.Provider value={contextValue}>{children}</ClientsLayoutContext.Provider>
  )
}

export const ClientsLayout = ({
  isPortfolioManagerScreen
}: {
  isPortfolioManagerScreen?: boolean
}) => (
  <ClientsLayoutProvider isPortfolioManagerScreen={isPortfolioManagerScreen}>
    <LeftSideBar
      leftElement={<Navigation />}
      mainElement={<ClientsWithState />}
      topBarElement={<UserMenuTopBar />}
    />
  </ClientsLayoutProvider>
)

export const useClientsLayout = () => {
  const context = React.useContext(ClientsLayoutContext)

  if (context === undefined) {
    throw new Error('useComponent must be used within a ClientsLayout component')
  }

  return context
}
